// src/pages/EntitiesListPage.tsx
import React, { useEffect, useState } from 'react';
import AgentInfo from '../organisms/AgentInfo';
import { useLocation, useParams } from'react-router-dom';
import MainLayout from '../../Layouts/MainLayout';
import { service } from '../../../services/AxiosServices';
const AgentDashboard: React.FC = () => {
const {id} = useParams()
const location = useLocation();
const [loading,setLoading] = useState(false)
  
const [crewname, setCrewname] = useState("");
useEffect(() => {

const singleCrew = async () => {
  try {
    setLoading(true)
    const response = await service<any>("/api/get-all-crew", "post", {
      project_id: localStorage.getItem("project_id"),
    });
    const formattedData = response.data.crews.find(
      (ele: any) => ele.id == id
    )?.crew_name;
    if (formattedData) {
      setCrewname(formattedData);
     
    }
  } catch (err) {
    console.error("Error fetching crew name:", err);
  }
  finally{
   
    setLoading(false)
  }
};
singleCrew();
}, [id]);

  
    return (
        <>
             <MainLayout>
                <AgentInfo crewName = {crewname} crewId={id || ''}/>
             </MainLayout>
        </>
    );
};

export default AgentDashboard;
